import { useEffect, useRef } from "react";
import gsap from "gsap";

const Cube = ({ size, style, className = "" }) => (
  <div className={`shape-3d ${className}`} style={style}>
    <div className="cube" style={{ "--s": `${size}px` }}>
      <i /><i /><i /><i /><i /><i />
    </div>
  </div>
);

export const FloatingShapes = ({ dense = false }) => {
  const root = useRef(null);
  // Su schermi piccoli le forme restano dentro l'area visibile (niente posizioni negative) e più piccole
  const mobile = typeof window !== "undefined" && window.matchMedia("(max-width: 639px)").matches;

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.utils.toArray(".cube").forEach((el, i) => {
        gsap.to(el, { rotateX: 360, rotateY: 360, duration: 22 + i * 6, repeat: -1, ease: "none" });
        gsap.to(el, { y: i % 2 ? -18 : 18, duration: 3 + i, repeat: -1, yoyo: true, ease: "sine.inOut" });
      });
      gsap.utils.toArray(".ring-3d").forEach((el, i) => {
        gsap.to(el, { rotateX: 70, rotateZ: 360, duration: 18 + i * 4, repeat: -1, ease: "none", transformPerspective: 800 });
      });
      gsap.fromTo(".shape-3d", { opacity: 0, scale: 0.6 }, { opacity: 1, scale: 1, duration: 1.2, stagger: 0.15, ease: "power3.out" });
    }, root);
    const onMove = (e) => {
      const px = e.clientX / window.innerWidth - 0.5;
      const py = e.clientY / window.innerHeight - 0.5;
      gsap.to(root.current, { x: px * -30, y: py * -20, duration: 1.2, ease: "power2.out" });
    };
    window.addEventListener("mousemove", onMove);
    return () => { ctx.revert(); window.removeEventListener("mousemove", onMove); };
  }, []);

  if (mobile) {
    return (
      <div ref={root} aria-hidden className="persp pointer-events-none absolute inset-0 -z-0 overflow-hidden">
        <Cube size={48} style={{ top: 30, right: 56 }} />
        <Cube size={26} style={{ top: 120, right: 130 }} />
        <div className="shape-3d" style={{ top: 14, right: 90 }}><div className="ring-3d" style={{ "--s": "90px" }} /></div>
      </div>
    );
  }

  return (
    <div ref={root} aria-hidden className="persp pointer-events-none absolute inset-0 -z-0 overflow-hidden">
      <Cube size={90} style={{ top: dense ? "12%" : "-6%", right: dense ? "8%" : "2%" }} />
      <Cube size={46} style={{ bottom: dense ? "18%" : "auto", top: dense ? "auto" : "4%", right: dense ? "22%" : "14%" }} />
      <Cube size={28} style={{ top: dense ? "40%" : "14%", right: dense ? "36%" : "8%" }} className="hidden sm:block" />
      <div className="shape-3d" style={{ top: dense ? "18%" : "-8%", right: dense ? "10%" : "4%", transform: "translate(-40px,-40px)" }}><div className="ring-3d" style={{ "--s": dense ? "180px" : "140px" }} /></div>
      {dense && <Cube size={60} style={{ top: "60%", left: "6%" }} className="hidden lg:block" />}
    </div>
  );
};
